import React from 'react'
import Transactions from './Transactions'

import '../styles/history.css' 

const History = () => {
  return (
    <>
      <div className="history beforeWas">
        <div className="histCont zl1">
          <div className="hist-Cont">
            <Transactions />
          </div>
        </div>
      </div>
    </>
  )
}

export default History